module.exports = __webpack_public_path__ + "media/images/avatar-799057dd8692d65abd5ef7c77c7e1283.png";